import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import { selectToken } from "../../../auth/auth.selector";
// import PaginatedTable from "../../../components-bootstrap/PaginatedTable";
import {
  convertStraight,
  convertThenFormat,
  currentMonthName,
  currentMonthNumber,
  currentYear,
  formatDateTimezon,
} from "../../../common-data/Converts";
import { BodyBuilder } from "../../../../exports/Images";
import ModalHeader from "../../../ModalHeader";
import UserDetails from "../../../incentive-system/user-details/UserDetails";
import FiltersTrainerDetails from "./FiltersTrainerDetails";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import PayoutsTable from "../../../components-bootstrap/PayoutsTable";
import { fetchApiDataDup } from "../../../../redux/reducers/commonApiSlice";
import { ptMembers } from "../../../../data/ApiEndpoints";
import { parseQueryStringToObject } from "../../../common-data/Conversions";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";

const PtDetails = ({ allInfo, filters, performanceEvaluation }) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);

  const { loadingDup: loading, dataDup } = useSelector((state) => state.common);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const iniAllFilters = {
    selectedMonth:
      allInfo.cardName === "pt-this-month"
        ? {
            label: currentMonthName,
            value: currentMonthNumber,
          }
        : "",
    selectedYear: {
      label: currentYear,
      value: currentYear,
    },
    selPTPlanStatus: "",
    selRegularPlanStatus: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniTbFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allInfo.gymId
      ? allInfo.gymId
      : filters.gym_id
      ? filters.gym_id
      : "",
    trainer_id: allInfo.trainerId
      ? allInfo.trainerId
      : filters.trainer_id
      ? filters.trainer_id
      : "",
    month: allFilters.selectedMonth?.value || "",
    year: allFilters.selectedYear?.value || "",
    type: allInfo.cardName === "pt-this-month" ? "" : allInfo.cardName || "",
    regular_subscription_status: allFilters.selRegularPlanStatus?.value || "",
    subscription_status: allFilters.selPTPlanStatus?.value || "",
  };
  const [tbFilters, setTbFilters] = useState(iniTbFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [allQps, setAllQps] = useState("");
  const [userDetailsModal, setUserDetailsModal] = useState(false);
  const [currentUserModal, setCurrentUserModal] = useState({
    status: false,
    data: null,
  });
  const iniModValues = {
    isModalOpen: false,
    cardType: "",
    partialDetails: [],
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setTbFilters(iniTbFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setTbFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getData(filters) {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: ptMembers,
        payload: {
          filters: filters,
        },
        token: token,
      })
    );
  }

  useEffect(() => {
    setTbFilters((prevs) => ({
      ...prevs,
      type: allInfo.cardName === "pt-this-month" ? "" : allInfo.cardName || "",
      gym_id: allInfo.gymId
        ? allInfo.gymId
        : filters.gym_id
        ? filters.gym_id
        : "",
      trainer_id: allInfo.trainerId
        ? allInfo.trainerId
        : filters.trainer_id
        ? filters.trainer_id
        : "",
      month: allFilters.selectedMonth?.value || "",
      year: allFilters.selectedYear?.value || "",
      regular_subscription_status: allFilters.selRegularPlanStatus?.value || "",
      subscription_status: allFilters.selPTPlanStatus?.value || "",
    }));
  }, [
    allInfo?.cardName,
    allInfo.gymId,
    filters.gym_id,
    allInfo.trainerId,
    filters.trainer_id,
    allFilters,
    allFilters.selRegularPlanStatus,
    allFilters.selPTPlanStatus,
  ]);

  useEffect(() => {
    const filteredParams = Object.entries(tbFilters)
      .filter(([key, value]) => value !== "")
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    const queryString = filteredParams ? `&${filteredParams}` : "";
    setAllQps(queryString);
  }, [tbFilters]);

  useEffect(() => {
    if (allInfo.cardName === "pt-this-month" && allQps?.includes("month")) {
      const sendableObj = parseQueryStringToObject(allQps);

      if (performanceEvaluation) {
        sendableObj.performance_evaluation = "true";
      }

      getData(sendableObj);
    } else if (allInfo.cardName !== "pt-this-month" && allQps) {
      const sendableObj = parseQueryStringToObject(allQps);

      if (performanceEvaluation) {
        sendableObj.performance_evaluation = "true";
      }

      getData(sendableObj);
    }
  }, [isPage, allQps]);

  useEffect(() => {
    if (dataDup?.status && dataDup?.data?.length > 0) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: dataDup?.data || [],
        pagination: dataDup?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [dataDup]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setTbFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumn = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">{row?.gym_name || "NA"}</p>
        </div>
      ),
    },
    {
      dataField: "member_name",
      text: "Member Detail",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.member_profile || BodyBuilder}
            alt={row?.member_name || "NA"}
            className="image"
          />
          <p
            className="name hoverBlue link"
            style={{
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              setUserDetailsModal(true);
              setCurrentUserModal({ status: true, data: row });
            }}>
            {row?.member_name || "NA"}
            <br />
            <small>{row?.member_mobile || ""}</small>
          </p>
        </div>
      ),
    },
    {
      dataField: "trainer_name",
      text: "trainer Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column" style={{ gap: "0" }}>
          <p className="info minWidth100">
            {row?.trainer_name || "NA"}
            <br />{" "}
            <small style={{ color: "gray" }}>
              {row?.experience_level || ""}
            </small>
          </p>
        </div>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className={`info ${row?.is_partial === "true" ? "link" : ""}`}
            onClick={() =>
              row?.is_partial === "true"
                ? setModValues((prevs) => ({
                    ...prevs,
                    isModalOpen: true,
                    cardType: "partial_details",
                    partialDetails: row?.payment_details || [],
                  }))
                : null
            }>
            {row?.is_partial === "true" ? "Partial" : "Full"}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "price",
    //   text: "Amount/(Online,Cash)",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150 bold">
    //         {row?.is_partial === "true"
    //           ? `₹${convertThenFormat(
    //               row?.total_partial_price || 0
    //             )} / ${convertThenFormat(row?.price || 0)}`
    //           : `₹${convertThenFormat(row?.price || 0)}`}
    //         {/* {row?.price ? convertThenFormat(row.price) : 0} */}
    //         <br />
    //         <small style={{ fontWeight: "500" }}>
    //           (₹
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_online
    //               : row?.total_online || 0
    //           )}{" "}
    //           /{" "}
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_cash
    //               : row?.total_cash || 0
    //           )}
    //           )
    //           <br />
    //           {row?.plan_name || ""}
    //         </small>
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">₹{convertThenFormat(row?.price || 0)}</p>
        </div>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            {row?.is_partial === "true"
              ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_cash
                : row?.total_cash || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "duration",
      text: "duration",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">{row?.duration || "0"} Days</p>
        </div>
      ),
    },
    {
      dataField: "session_status",
      text: "session status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}>
            {row?.session_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90">
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.regular_subscription_status === "active"
                  ? "#B4E7B9"
                  : "#F6EFEF",
              color:
                row?.regular_subscription_status === "active"
                  ? "#0A701B"
                  : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}>
            {row?.regular_subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
              color:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}>
            {row?.subscription_status || "NA"}
          </p>
        </div>
      ),
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        onRequestClose={() => {
          setUserDetailsModal(false);
          setCurrentUserModal({ status: false, data: null });
        }}
        ariaHideApp={false}
        isOpen={userDetailsModal}>
        <div
          className="modal-body-k p-3 large bg-white rounded-5"
          style={{ zIndex: "999" }}>
          <ModalHeader
            title={"User Details"}
            onClick={() => {
              setUserDetailsModal(false);
              setCurrentUserModal({ status: false, data: null });
            }}
          />
          <UserDetails row={currentUserModal?.data} />
        </div>
      </Modal>

      <Modal
        isOpen={modValues.isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}>
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={modValues.cardType?.replace(/_/g, " ")}
            onClose={closeModal}
          />

          {modValues.cardType === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <FiltersTrainerDetails
        name={"pt-details-info"}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumn}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default PtDetails;
